<template>
  <v-app>
    <v-app-bar v-if="!freeLayout" app absolute elevate-on-scroll>
      <v-app-bar-nav-icon
        v-if="!drawer"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <div v-if="$route.params.id">
          <div v-for="item in items" :key="item.title">
            <div v-if="item.route === $route.params.id">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div v-else>
          {{ $route.meta.title }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        color="primary"
        outlined
        small
        router
        :to="{ name: 'Request' }"
        class="d-none d-md-flex"
      >
        <v-icon class="text-body-2 ml-2">mdi-office-building-outline</v-icon>
        <small>درخواست ثبت اطلاعات شرکت</small>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-if="!freeLayout"
      v-model="drawer"
      color="primary"
      :width="300"
      app
      right
    >
      <div class="d-flex justify-center mt-5 mb-4">
        <div>
          <v-img alt="app logo" src="./assets/logo.png" />
        </div>
      </div>
      <div class="text-center white--text">بانک اطلاعات صنایع</div>
      <v-list dense class="mt-5">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          router
          :to="{ name: 'Companies', params: { id: item.route } }"
          dark
          mandatory
          large
          class="my-3"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="pa-2 w-100">
        <v-btn
          depressed
          color="white"
          outlined
          small
          router
          :to="{ name: 'Request' }"
          class="d-flex d-md-none mb-2"
        >
          <v-icon class="text-body-2 ml-2">mdi-office-building-outline</v-icon>
          <small>درخواست ثبت اطلاعات شرکت</small>
        </v-btn>
        <v-btn
          v-show="!user"
          depressed
          outlined
          small
          block
          color="white"
          class="mb-2"
          router
          :to="{ name: 'Login' }"
        >
          <v-icon class="text-body-2 ml-2">mdi-account-key-outline</v-icon>
          <small>ورود</small>
        </v-btn>
        <v-btn
          v-if="user && user.type === 'admin'"
          depressed
          outlined
          small
          block
          color="white"
          class="mb-2"
          router
          :to="{ name: 'AdminCompanies' }"
        >
          <v-icon class="text-body-2 ml-2">mdi-cog-outline</v-icon>
          <small>بخش ادمین</small>
        </v-btn>
        <v-btn
          v-if="user"
          depressed
          outlined
          small
          block
          color="white"
          @click="handleSingoutUser"
        >
          <v-icon class="text-body-2 ml-2">mdi-account-minus-outline</v-icon>
          <small>خروج</small>
        </v-btn>
      </div>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid class="pa-5 pb-16">
        <v-row v-if="!freeLayout && !adminArea">
          <v-col cols="12" md="9">
            <router-view></router-view>
          </v-col>
          <v-col cols="12" md="3">
            <AD />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
      <v-footer class="text-left" absolute bottom>
        طراحی و توسعه توسط
        <strong class="px-1">بسپار</strong> - 1399
        <small class="mr-2">(انتشار اولیه 1378)</small>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import AD from "./components/Advertise";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    AD
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "پلیمریس",
    // all titles will be injected into this template
    titleTemplate: "%s | بانک اطلاعاتی بسپار",
    description: "بانک اطلاعاتی شرکت های پلیمر",
    robots: ""
  },
  data() {
    return {
      drawer: true,
      items: [
        {
          title: "پلاستیک، لاستیک و کامپوزیت",
          icon: "mdi-gate-nor",
          route: "plastic"
        },
        {
          title: "پوشرنگ، رزین و چسب",
          icon: "mdi-bottle-tonic-outline",
          route: "glue"
        },
        {
          title: "بسته بندی",
          icon: "mdi-package-variant-closed",
          route: "packing"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["user", "error", "message", "messageState", "messageType"]),
    freeLayout() {
      if (this.$route.meta.layout == "none") {
        return true;
      } else {
        return false;
      }
    },
    adminArea() {
      if (this.$route.meta.layout == "admin") {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.$store.dispatch("checkUser");
    this.setToken();
  },
  updated() {
    this.setToken();
  },
  methods: {
    handleSingoutUser() {
      this.$store.dispatch("signoutUser");
    },
    setToken() {
      this.$api.defaults.headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: this.$cookies.get("jwt")
      };
    }
  }
};
</script>

<style>
.thin {
  font-family: "yekan-thin" !important;
}
</style>
